import React from "react";
import "./footer.css";

function Footer() {
  return (
    <div className="footerContainer">
      <p className="socialmediaLink">
        <b><a target="_blank" href="https://www.linkedin.com/company/auragreenearth/">Linkedin</a></b>
      </p>
      <p>
        Mail Id:- <b>greenauraearth@gmail.com</b>
      </p>
    </div>
  );
}

export default Footer;
